import { h } from 'preact';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { Modal } from '../../../common/modal';
import { usePlayerContext, useStyles } from '../../../../hooks';
import Tracks from './Tracks';
import { Button } from '../../../common';

import {
  TRACKLIST_MODAL_BASIC_STYLE,
  TRACK_DIALOG_CLOSE_LABEL_STYLE
} from './styles';
import { MODAL_CLOSING_BUTTON_STYLE } from '../../../common/modal/types';

import { USER_TRACK_LIST_OPENED, USER_CLICK } from '../../../../../types';
import { isMultilang } from '../../../../../utils/tracks';
import { useRegisterDialog } from '../../../../context/DialogContext';

export const LABEL_AUDIO_ET_SOUS_TITRES = 'Audio et sous-titres';
function TracksMenu({
  hidden,
  subtitlesAvailable,
  subtitleSelected,
  audiosAvailable,
  audioSelected,
  name,
  disableFocus,
  isTv,
  ...extraProps
}) {
  const player = usePlayerContext();
  const setStyles = useStyles();

  const iconRef = useRef(null);
  const closeIconRef = useRef(null);

  const [isOutsideModal, setIsOutsideModal] = useState(null);
  const [isModalOpened, setIsModalOpened] = useState(false);

  useRegisterDialog({
    id: name, openingMode: 'click', state: [isModalOpened, setIsModalOpened]
  });

  const size = setStyles({
    extraSmall: { width: 16 },
    small: { width: 24 },
    medium: { width: 36 },
    'large+extraLarge': { width: 44 },
    'largeTv+extraLargeTv': { width: 60 }
  }).width;

  const modalWrapperStyles = setStyles({
    default: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
    'medium+large+extraLarge': { position: 'relative' }
  });
  const modalStyles = setStyles({
    'medium+large+extraLarge': { top: 'initial', bottom: -5, right: -5, width: 505, maxWidth: 650, maxHeight: 600 }
  });

  const closingButtonStyle = {
    ...setStyles(MODAL_CLOSING_BUTTON_STYLE),
    ...setStyles({
      'default+extraSmall': { top: 21, right: 0 },
      small: { top: 26, right: 21 },
      medium: { top: 22, right: 21 },
      'large+extraLarge': { top: 30, right: 20 }
    })
  };

  const closeButtonLabelStyle = setStyles(TRACK_DIALOG_CLOSE_LABEL_STYLE);

  const onClickClose = useCallback(() => {
    // Local state
    setIsModalOpened(false);

    // Store state
    player.panelController.isTrackViewActive$.next(false);
  }, [setIsModalOpened]);

  const onClickOpen = useCallback(() => {
    // Local state
    setIsModalOpened((state) => !state);

    // Store state
    player.userEvents$.next({
      action: USER_TRACK_LIST_OPENED,
      source: USER_CLICK,
      value: isMultilang(audiosAvailable, subtitlesAvailable)
    });
    player.panelController.isTrackViewActive$.next(true);
  }, [setIsModalOpened]);

  useEffect(() => {
    if (isModalOpened && closeIconRef.current) {
      setIsOutsideModal(false);
      closeIconRef.current?.focus();
    }
  }, [isModalOpened, isOutsideModal]);

  return (
    !isModalOpened ? (
      <Button
        type="icon"
        icon={isTv ? 'tracks-active' : 'tracks'}
        label={LABEL_AUDIO_ET_SOUS_TITRES}
        size={size}
        onClick={onClickOpen}
        iconRef={iconRef}
        openingMode="click"
        {...extraProps}
      />
    ) : (
      <div style={modalWrapperStyles}>
        <Modal
          show={isModalOpened}
          trap
          onChange={(openedState) => {
            setIsOutsideModal(true);
            setIsModalOpened(openedState);
          }}
          styles={TRACKLIST_MODAL_BASIC_STYLE}
          stylesDirectOverride={modalStyles}
          closingButtonStyle={closingButtonStyle}
          closeComponent={(
            <Button
              type="icon"
              openingMode="click"
              label="Fermer"
              forceLabel
              disableFocus={false}
              ariaLabel={`Fermer ${LABEL_AUDIO_ET_SOUS_TITRES}`}
              last
              zone="right"
              onClick={onClickClose}
              onKeyDown={onClickClose}
              size={setStyles({
                extraSmall: { width: 16 },
                'small+medium+large+extraLarge': { width: 24 }
              }).width}
              icon="close"
              xs
              iconRef={closeIconRef}
              name="btn-close-tracks-modal"
              ariaHidden={false}
              labelStyle={closeButtonLabelStyle}
            />
          )}
        >
          <Tracks
            subtitlesAvailable={subtitlesAvailable}
            subtitleSelected={subtitleSelected}
            audiosAvailable={audiosAvailable}
            audioSelected={audioSelected}
            isTv={isTv}
          />
        </Modal>
      </div>
    )
  );
}

export default TracksMenu;
